import React, { useState, useContext, useEffect } from 'react'
import Logo from '../assets/MyLogo.gif'
import MenuItems from './MenuItems'
import { UserContext } from '../context/UserContext'

const SideMenu = (props) => {
    const { onCollapse } = props
    const [inactive, setInactive] = useState(false)    
    const { logout } = useContext(UserContext)

    useEffect(() => {
        if (inactive) {
            document.querySelectorAll('.sub-menu').forEach(element => {
                element.classList.remove('active')
            })
        }               
        onCollapse(inactive)
    }, [inactive, onCollapse])

    useEffect(() => {
        if(window.innerWidth < 576)
        { 
            setInactive(true) 
        } 
    }, []) 

    const MenuItemList = [
        { title: 'Dashboard', to: '/dashboard', iconClassName: "bi bi-speedometer2" },
        {
            title: 'Content',
            to: '/content',
            iconClassName: "bi bi-vector-pen",
            onClick: () => { if (inactive) { setInactive(false) } },
            SubMenus: [
                { title: 'College News', to: '/content/college-news' },
                { title: 'Notice & Announcement', to: '/content/notice' }
            ]
        },
        { title: 'Gallary', to: '/gallary', iconClassName: "bi bi-images" },
        { title: 'Exam Question Paper', to: '/exam-paper', iconClassName: "bi bi-question-circle" },
        { title: 'Logout', to: '/logout', onClick: () => logout(), iconClassName: "bi bi-box-arrow-right" }
    ]

    return (   
    <>    
        <div className="mobile-top-bar">
            <div className="top-section">
                <div className="logo">
                    <img src={Logo} alt="logo" />
                </div>
                <div className="company-name">
                    <h3>Durga College</h3>
                </div>
                <div onClick={() => setInactive(!inactive)} className="toggle-menu-btn">
                    {
                        !inactive ? <i className="bi bi-x"></i> : <i className="bi bi-list"></i>
                    }
                </div>                             
            </div>          
        </div> 
        <div className={`side-menu ${inactive ? 'inactive' : ''}`}>
            <div className="top-section">
                <div className="logo">
                    <img src={Logo} alt="logo" />
                </div>
                <div className="company-name">
                    <h3>Durga College</h3>
                </div>
                <div onClick={() => setInactive(!inactive)} className="toggle-menu-btn">
                    {
                        !inactive ? <i className="bi bi-arrow-left-square-fill"></i> : <i className="bi bi-arrow-right-square-fill"></i>
                    }
                </div>                             
            </div>

            <div className="search-controller">
                <button type="button" className="search-btn">
                    <i className="bi bi-search"></i>
                </button>
                <input type="text" placeholder="Search" />
            </div>

            <div className="divider"></div>


            <div className="main-menu">
                <ul>
                    {
                        MenuItemList.map((menu, idx) => {
                            return <MenuItems key={idx} {...menu} />
                        })
                    }
                </ul>
            </div>

            <div className="side-menu-footer">
                <div className="avatar">
                    <img src={Logo} alt="user" />
                </div>
                <div className="user-info">
                    <h5>Ajay Dewangan</h5>
                    <p>ajaydewangan215@gmail.com</p>
                </div>
            </div>
        </div>
    </>
    )
}

export default SideMenu
